import React from 'react'
import { forwardRef } from '@grupoboticario/flora-react-system'
import { FloraRadioProps } from './types'
import {
  FloraStyledRadioWrapper,
  FloraStyledRadioInput,
  FloraStyledRadioLabel,
  FloraStyledRadioSpan,
} from './styles'
import { useFloraRadio } from './useFloraRadio'

export const FloraRadio = forwardRef<'input', FloraRadioProps>((props, forwardedRef) => {
  const {
    id,
    textSize = 'medium',
    status = 'neutral',
    surfaceColor = 'light',
    label,
    disabled,
    'autotagging-flora': autotaggingFlora = 'off',
    'data-autotagging-flora-section': dataAutotaggingFloraSection = '',
    'data-flora-text': dataFloraText,
    'aria-label': ariaLabel,
    ...rest
  } = props

  useFloraRadio(props)

  return (
    <FloraStyledRadioWrapper>
      <FloraStyledRadioInput
        {...rest}
        id={id}
        ref={forwardedRef}
        as="input"
        data-flora="radio"
        autotagging-flora={autotaggingFlora}
        data-flora-text={dataFloraText ?? ariaLabel ?? label}
        data-autotagging-flora-section={dataAutotaggingFloraSection}
        type="radio"
        status={status}
        textSize={textSize}
        surfaceColor={surfaceColor}
        disabled={disabled}
        aria-label={ariaLabel ?? label}
        aria-invalid={status === 'error'}
      />
      <FloraStyledRadioLabel htmlFor={id} disabled={Boolean(disabled)} aria-hidden>
        <FloraStyledRadioSpan />
        {label}
      </FloraStyledRadioLabel>
    </FloraStyledRadioWrapper>
  )
})
